module.exports = __webpack_public_path__ + "img/banner1.782fe7e8.jpg";